document.addEventListener("submit", function (event) {
  if (!window.themeVariables?.settings?.pauseOrders) return;

  const form = event.target;
  if (!(form instanceof HTMLFormElement)) return;

  const submitter = event.submitter;
  const isCheckout = submitter?.getAttribute("name") === "checkout";
  const isProductForm = form.closest("product-form") !== null || (form.getAttribute("action") || "").includes("/cart/add");

  if (isProductForm || isCheckout) {
    event.preventDefault();
    event.stopImmediatePropagation();
  }
}, true);

document.addEventListener("DOMContentLoaded", function(event) {
  try {
    document.querySelector(".shopify-section--main-product .product-gallery__image-list").addEventListener("click", ()=>
    {
      document.getElementsByClassName("product-gallery__zoom-button")[0].click();
    });
  } catch (error) {
    console.error("error in custom.js: " + error);
  }
});

class DragScroll extends HTMLElement {
  connectedCallback() {
    if (this._dragScrollBound) return;
    this._dragScrollBound = true;

    this._isPointerDown = false;
    this._hasDragged = false;
    this._startX = 0;
    this._scrollLeft = 0;
    this._pointerId = null;

    this.addEventListener("pointerdown", this._onPointerDown.bind(this));
    this.addEventListener("pointermove", this._onPointerMove.bind(this));
    this.addEventListener("pointerup", this._onPointerUp.bind(this));
    this.addEventListener("pointercancel", this._onPointerUp.bind(this));
    this.addEventListener("click", this._onClick.bind(this), true);
    this.addEventListener("dragstart", (event) => event.preventDefault());
  }

  _isScrollable() {
    return this.scrollWidth > this.clientWidth + 1;
  }

  _onPointerDown(event) {
    // Native touch scrolling already feels right on mobile; drag-to-scroll is for mouse/pen.
    if (event.pointerType === "touch") return;
    if (event.pointerType === "mouse" && event.button !== 0) return;
    if (!this._isScrollable()) return;

    this._isPointerDown = true;
    this._hasDragged = false;
    this._startX = event.clientX;
    this._scrollLeft = this.scrollLeft;
    this._pointerId = event.pointerId;
    this.classList.add("is-dragging");

    try {
      this.setPointerCapture(event.pointerId);
    } catch (error) {
      // Ignore browsers that reject pointer capture.
    }
  }

  _onPointerMove(event) {
    if (!this._isPointerDown || event.pointerId !== this._pointerId) return;

    const deltaX = event.clientX - this._startX;

    if (Math.abs(deltaX) > 5) {
      this._hasDragged = true;
    }

    if (this._hasDragged) {
      event.preventDefault();
      this.scrollLeft = this._scrollLeft - deltaX;
    }
  }

  _onPointerUp(event) {
    if (!this._isPointerDown || event.pointerId !== this._pointerId) return;

    this._isPointerDown = false;
    this._pointerId = null;
    this.classList.remove("is-dragging");

    // Keep the click suppressor active briefly for the synthetic click.
    if (this._hasDragged) {
      window.setTimeout(() => {
        this._hasDragged = false;
      }, 0);
    }
  }

  _onClick(event) {
    if (!this._hasDragged) return;
    event.preventDefault();
    event.stopPropagation();
    this._hasDragged = false;
  }
}

if (!window.customElements.get("drag-scroll")) {
  window.customElements.define("drag-scroll", DragScroll);
}
